// 获取state中的值
export default {
  // 获取当前用户信息
  currentUser: state => state.currentUser,
  // 获取动态路由信息
  asyncRouters: state => state.asyncRouters,
  // 获取资源权限列表
  allPermissionList: state => state.allPermissionList,
  // 用户基本信息
  userBaseInfo: state => state.userBaseInfo,
  // 获取系统中角色列表
  sysRoleList: state => state.sysRoleList,
  // 获取用户状态字典信息
  userStatusDicList: state => state.userStatusDicList,
  // 获取医生学位字典信息
  doctorDegreeDicList: state => state.doctorDegreeDicList,
  // 获取医生职称字典信息
  doctorTitleDicList: state => state.doctorTitleDicList,
  // 获取医院等级字典信息
  hospitalDegreeDicList: state => state.hospitalDegreeDicList,
  // 提现状态字典信息
  withdrawStatusDicList: state => state.withdrawStatusDicList,
  // 正在审核的提现ID
  auditWithdrawId: state => state.auditWithdrawId,
  // 获取订单详情数据
  orderDetailInfo: state => state.orderDetailInfo,
  // 获取当前管理员注册步骤
  registerStep: state => state.registerStep,
  // 获取当前保存的注册用户信息
  registerUserInfo: state => state.registerUserInfo,
  // 获取医院名称ID列表
  hospitalNameIdList: state => state.hospitalNameIdList,
  // 获取公司名称ID列表
  companyNameIdList: state => state.companyNameIdList,
  // 获取积分状态字典表信息
  pointStatusList: state => state.pointStatusList,
  // 获取积分操作类型字典表信息
  pointHandleTypeList: state => state.pointHandleTypeList,
  // 获取医院状态字典表信息
  hospitalStatusDicList: state => state.hospitalStatusDicList,
  // 获取医生状态字典表信息
  doctorStatusDicList: state => state.doctorStatusDicList,
  // 获取订单状态字典表信息
  orderStatusDicList: state => state.orderStatusDicList,
  // 获取订单病理类型字典表信息
  orderPathologyTypeDicList: state => state.orderPathologyTypeDicList,
  // 获取食道筛订单状态字典表信息
  esophagusStatusDicList: state => state.esophagusStatusDicList,
  // 获取食道筛订单来源字典表信息
  esophagusFromDicList: state => state.esophagusFromDicList,
  // 获取食道筛产品状态字典表信息
  epsSNStatusDicList: state => state.epsSNStatusDicList,
  // 获取实验室列表
  laboratoryIdNameIdList: state => state.laboratoryIdNameIdList,
  // 获取快递付款方式
  expressPayMethodDicList: state => state.expressPayMethodDicList,
  // 获取快递单位
  expressListDicList: state => state.expressListDicList,
  // 获取收货方式
  receivingTypeListDicList: state => state.receivingTypeListDicList,
  // 添加怡早学订单详情记录类型字典表
  recordTypeList: state => state.recordTypeList,
  // 添加代理商列表，用于下拉查询
  agentList: state => state.agentList,
  // 添加微信公众号菜单列表
  wechatMenuList: state => state.wechatMenuList
}



// WEBPACK FOOTER //
// ./src/store/modules/getters.js